import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlignJustify = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 21,
			y1: 6,
			x2: 3,
			y2: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 21,
			y1: 12,
			x2: 3,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 21,
			y1: 18,
			x2: 3,
			y2: 18
		})
	]
});
export default SvgAlignJustify;
